import { createFileRoute } from '@tanstack/react-router'

/**
 * Route definition for the platform-admin agency approval queue.
 * The persona guard lives in the lazy component (index.lazy.tsx), not here.
 *
 * `beforeLoad` runs before the context store is hydrated from /auth/contexts,
 * so a persona check here always sees `active = null` on a fresh page load and
 * would redirect every user, including the SA the route is meant to admit.
 * Component-level guards avoid this timing issue — they re-render as the store
 * populates and are fail-closed: nothing renders until persona resolves.
 */
export const Route = createFileRoute('/platform/agencies/')({})
